import { render, staticRenderFns } from "./AthleteSelfAssessmentForm.vue?vue&type=template&id=4d25b84c&scoped=true&"
import script from "./AthleteSelfAssessmentForm.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentForm.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSelfAssessmentForm.vue?vue&type=style&index=0&id=4d25b84c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d25b84c",
  null
  
)

export default component.exports